const axios = require('axios')

module.exports = async (opts = {}) => {
  const topics = await axios.get(
    process.env.GATSBY_FORUM_SERVICE_URL + '/api/query/topics'
  )

  return topics
}
